import { useEffect, useState } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { projectAdacter } from 'adapters';
import { contextProject } from 'context';
import { useForm } from 'react-hook-form';
import { projectService } from 'services';
import useErrors from 'hooks/useErrors';
import { setItemToStore } from 'helpers/utils';

const useProject = ({ query = false, id = false }) => {
 const { setError } = useErrors();
 const { createProject, getProjects, getProject } = projectService.useApiProjects();
 const mutateProject = useMutation(createProject);
 const [isLoaded, setIsLoaded] = useState(!!id);
 const [dataProject, setDataProject] = useState(false);
 const { project, select, setSelect } = contextProject();

 const {
  watch,
  reset,
  trigger,
  register,
  setValue,
  handleSubmit,
  formState: { errors }
 } = useForm({ defaultValues: { ...project, amenities: select.amenities.map(e => e.value.toUpperCase()) } });

 useQuery(['project'], () => getProject(id), {
  onSuccess: data => setDataProject(data),
  onSettled: () => setIsLoaded(false),
  onError: err => console.log(err),
  enabled: !!id
 });

 const { data } = useQuery(['projects'], getProjects, { enabled: query });

 const onSubmitData = async project => {
  setIsLoaded(true);
  const newProject = await projectAdacter.create(project);
  console.log(newProject, 'antes de enviar');
  mutateProject.mutate(newProject, {
   onSuccess: obj => console.log(obj),
   onSettled: () => setIsLoaded(false),
   onError: err => setError(err)
  });
 };

 const onError = err => {
  console.log('se produjo un error ', err);
 };

 useEffect(() => {
  const subscription = watch((value, { name }) => {
   setItemToStore('createProyect', value);
   //console.log(value, 'el formulario cambio', name);
   if (name === 'amenities') setSelect(prev => ({ ...prev, amenities: value?.amenities.map(a => ({ value: a, label: a })) }));
  });
  return () => subscription.unsubscribe();
 }, [watch]);

 return {
  watch,
  register,
  handleSubmit,
  errors,
  setValue,
  reset,
  trigger,
  onError,
  onSubmitData,
  project,
  select,
  setSelect,
  isLoaded,
  dataProject,
  data
 };
};

export default useProject;
